// AUTO-GENERATED. Do not edit. Regenerated by scripts/generate-build-info.js.
// Runs on prestart/prebuild — see package.json scripts.
export const BUILD_VERSION = "2.1.137";
export const GIT_COMMIT_SHORT = "646e05be";
export const BUILD_TIMESTAMP = "2026-11-03T14:30:42.367Z";
